module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./install.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/install.md
// module id = 0aZB
// module chunks = 0